import { Button } from '@cluey/cluey-components';

import { CheckIcon } from '../../../../../legacy/components';

export type SummerPauseAndDiscountInfoBoxProps = {
  handleCancelEnrolment: () => void;
};

const SummerPauseAndDiscountInfoBox = ({ handleCancelEnrolment }: SummerPauseAndDiscountInfoBoxProps) => {
  const reasonsToPause = [
    'Your enrolment stays active – no need to cancel.',
    'Any paid sessions move to Term 1 automatically.',
    <span>
      Plus, get <b>20% off</b> your first 5 unpaid Term 1 sessions when you return.
    </span>,
  ];

  return (
    <div className="mb-9 rounded-lg bg-slate-1 p-9">
      <div className="mb-6 w-fit rounded bg-yellow-3 px-2 font-bold uppercase text-black">Limited time offer</div>
      <div className="w-full rounded-lg">
        <div className="flex flex-row items-start justify-between">
          <p className="font-display text-2xl font-bold text-grey-6">Pause your plan – keep your savings!</p>
          <Button
            className="hidden font-bold normal-case sm:block"
            appearance="reverse"
            onClick={handleCancelEnrolment}
          >
            Cancel anyway
          </Button>
        </div>
        <p className="mt-6 text-lg">Take a break now and return refreshed for Term 1 – without losing your benefits.</p>
        <ul className="mt-6 flex flex-col gap-y-4 text-lg md:mr-4">
          {reasonsToPause.map((reason, index) => {
            return (
              <li key={`pause_benefits_${index}`} className="mt-1 flex items-start text-grey-6">
                <CheckIcon className="mr-2.5 flex-shrink-0 text-green-4" width={24} height={24} />
                {reason}
              </li>
            );
          })}
        </ul>
        <Button className="mt-6 w-full font-bold sm:hidden" appearance="reverse" onClick={handleCancelEnrolment}>
          Cancel anyway
        </Button>
      </div>
    </div>
  );
};

export default SummerPauseAndDiscountInfoBox;
